'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('documentService', function($http, $q, Upload, FileSaver, Blob, userStore, apiEndpointFactory,
  dispatcher, otppConstants, $cookies, adobeAnalyticsService, DocumentStore) {
  function getMbrToken(){
    return $cookies.get(otppConstants.tokenStorageKey);
  }

  // WAF can intercept requests with 5xx, 4xx and return 200 so need to check that 200 is indeed 200
  function isSuccessCreateNewResponse(response) {
    return response.status === 200 && !JSON.stringify(response.data).includes('Request Rejected');
  }

  return {
    getDocuments: (shouldLoad) => {
      let irn = userStore.getIrn();
      if (shouldLoad) {
        dispatcher.dispatch('document:setLoadingState', {general: true});
      }

      let endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/documents',
        authRequired: true,
        apiVersion: 1,
        allowedMethods: ['get']
      });

      if (irn !== undefined) {
        return endpoint.get()
          .then((response) => {
            dispatcher.dispatch('document:setDocuments', response.data);
            dispatcher.dispatch('document:setLoadingState', {general: false});
            return response.data;
          })
          .catch((response) => {
            dispatcher.dispatch('document:setLoadingState', {general: false});
            return $q.reject(response);
          });
      } else {
        dispatcher.dispatch('document:setLoadingState', {general: false});
        return $q.reject('IRN is undefined');
      }
    },
    getRequiredDocuments: () => {
      if(DocumentStore.getLoadingStates().required){
        return $q.reject('Call already in flight');
      }
      let irn = userStore.getIrn();
      dispatcher.dispatch('document:setLoadingState', {required: true});
      let endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/documents/outstanding',
        authRequired: true,
        allowedMethods: ['get']
      });

      if (irn !== undefined) {
        return endpoint.get().then((response) => {
          dispatcher.dispatch('document:setRequiredDocuments', response.data);
          dispatcher.dispatch('document:setLoadingState', {required: false});
          return response.data;
        }, (response) => {
          dispatcher.dispatch('document:setLoadingState', {required: false});
          return $q.reject(response);
        });
      } else {
        dispatcher.dispatch('document:setLoadingState', {required: false});
        return $q.reject('IRN is undefined');
      }
    },
    getTaxDocuments: (shouldLoad) => {
      let irn = userStore.getIrn();
      if (shouldLoad) {
        dispatcher.dispatch('document:setLoadingState', {tax: true});
      }

      let endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/documents/tax',
        authRequired: true,
        allowedMethods: ['get']
      });

      if (irn !== undefined) {
        return endpoint.get().then((response) => {
          dispatcher.dispatch('document:setTaxDocuments', response.data);
          dispatcher.dispatch('document:setLoadingState', {tax: false});
          return response.data;
        }).catch((response) => {
          dispatcher.dispatch('document:setLoadingState', {tax: false});
          return $q.reject(response);
        });
      } else {
        dispatcher.dispatch('document:setLoadingState', {tax: false});
        return $q.reject('IRN is undefined');
      }
    },
    getUploadedDocuments: () => {
      let irn = userStore.getIrn();
      dispatcher.dispatch('document:setLoadingState', {uploaded: true});

      let endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/documents/uploaded',
        authRequired: true,
        allowedMethods: ['get']
      });

      if (irn !== undefined) {
        return endpoint.get().then((response) => {
          dispatcher.dispatch('document:setUploadedDocuments', response.data);
          dispatcher.dispatch('document:setLoadingState', {uploaded: false});
          return response.data;
        }, (response) => {
          dispatcher.dispatch('document:setLoadingState', {uploaded: false});
          return $q.reject(response);
        });
      } else {
        dispatcher.dispatch('document:setLoadingState', {uploaded: false});
        return $q.reject('IRN is undefined');
      }
    },
    getUploadDocumentsCount: () => {
      let irn = userStore.getIrn();

      let endpoint = apiEndpointFactory.new({
        endpointUrl: `/${irn}/documents/review/count`,
        authRequired: true,
        allowedMethods: ['get']
      });

      return endpoint.get().then((response) => {
        dispatcher.dispatch('document:setSizeOfUploadedDocuments', response.data.documentsUnderReview);
        return response.data;
      });
    },
    createDocument: (file) => {
      let irn = userStore.getIrn();

      let form = new FormData();
      form.append('file', file);

      return Upload.upload({
        url: `${otppConstants.apiUrl}/${irn}/documents/new`,
        headers: {
          'Authorization': `Token ${getMbrToken()}`
        },
        data: {file: file}
      }).then((response) => {
        if (!isSuccessCreateNewResponse(response)) {
          response.status = 422;
          return response;
        }
        dispatcher.dispatch('document:addUploadedDocument', response.data);
        dispatcher.dispatch('document:setUploadProgress', 100);
        adobeAnalyticsService.trackDocCentreUploadSuccess();
        return response;
      }, (response) => {
        return response;
      }, (event) => {
        var progressPercentage = parseInt(100.0 * event.loaded / event.total);
        if (progressPercentage < 95) {
          dispatcher.dispatch('document:setUploadProgress', progressPercentage);
        }
      }).catch((response) => {
        return response;
      });
    },
    downloadGeneralDocument: (documentId, description) => {
      dispatcher.dispatch('document:setDownloadPending', true);
      let irn = userStore.getIrn();
      dispatcher.dispatch('document:markDocumentAsRead', documentId);

      $http({
        url: `${otppConstants.apiUrl}/${irn}/documents/download/${documentId}`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${getMbrToken()}`
        },
        responseType: 'blob'
      }).success((response) => {
        let blob = new Blob([response], {
          type: 'application/pdf'
        });
        FileSaver.saveAs(blob, `${description}.pdf`);
        dispatcher.dispatch('document:setDownloadPending', false);
      }).catch(() => {
        dispatcher.dispatch('document:setDownloadPending', false);
      });
    },
    downloadTaxDocumentDocManager: (documentId, description) => {
      dispatcher.dispatch('document:setDownloadPending', true);
      let irn = userStore.getIrn();
      dispatcher.dispatch('document:markTaxDocumentAsRead', documentId);

      $http({
        url: `${otppConstants.apiUrl}/${irn}/documents/download/${documentId}`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${getMbrToken()}`
        },
        responseType: 'blob'
      }).success((response) => {
        let blob = new Blob([response], {
          type: 'application/pdf'
        });
        FileSaver.saveAs(blob, `${description}.pdf`);
        dispatcher.dispatch('document:setDownloadPending', false);
      }).catch(() => {
        dispatcher.dispatch('document:setDownloadPending', false);
      });
    },
    downloadUploadedDocument: (documentId, description) => {
      dispatcher.dispatch('document:setDownloadPending', true);
      let irn = userStore.getIrn();
      let mimeType = () => {
        if (_.includes(description.toLowerCase(), '.pdf')) {
          return 'application/pdf';
        } else if (_.includes(description.toLowerCase(), '.png')) {
          return 'image/png';
        } else {
          return 'image/jpeg';
        }
      };

      $http({
        url: `${otppConstants.apiUrl}/${irn}/documents/download/${documentId}`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${getMbrToken()}`
        },
        responseType: 'blob'
      }).success((response) => {
        let blob = new Blob([response], {
          type: mimeType()
        });
        FileSaver.saveAs(blob, description);
        dispatcher.dispatch('document:setDownloadPending', false);
      }).catch(() => {
        dispatcher.dispatch('document:setDownloadPending', false);
      });
    },
    downloadTaxDocument: (year, type) => {
      dispatcher.dispatch('document:setDownloadPending', true);
      $http({
        url: `/members/app/api/documents/tax/${year}?type=${type}`,
        method: 'GET',
        responseType: 'blob'
      }).success((response) => {
        let blob = new Blob([response], {
          type: 'application/pdf'
        });
        FileSaver.saveAs(blob, `${type}_${year}.pdf`);
        dispatcher.dispatch('document:setDownloadPending', false);
      }).catch(() => {
        dispatcher.dispatch('document:setDownloadPending', false);
      });
    }
  };
});
